/* cart-upsell.js — one-tap add for the cart-drawer upsell row.
   Document-level delegation on purpose: the drawer's HTML is replaced via
   innerHTML on every cart update (renderContents), which kills inline scripts
   and element-bound listeners — a delegated handler survives re-renders. */
(function () {
  if (window.__lumCartUpsell) return;
  window.__lumCartUpsell = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cart-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('.cart-upsell__item');
    var sel = row ? row.querySelector('[data-cart-upsell-select]') : null;
    var variantId = sel ? sel.value : btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.setAttribute('disabled', 'disabled');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (drawer && drawer.renderContents && !state.errors && !state.status) {
          drawer.renderContents(state);
        } else if (state.errors || state.status) {
          btn.removeAttribute('disabled');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { btn.removeAttribute('disabled'); });
  });
})();
